import React from 'react';
import MembersTableSection from './MembersTableSection';
import {
    AccountManagementSegmentState,
    MemberState,
} from '../../../../../types/zinantis/members/membersType';
import useTranslate from '../../../../../customHooks/useTranslate';
import Card from '../../../../../muiComponents/Card';

interface MembersTableViewProps {
    members: MemberState[];
    segments: AccountManagementSegmentState[];
    membersWithoutSegment: MemberState[];
    connectedMembers: MemberState[];
    newMembers: MemberState[];
}

const MembersTableView = (props: MembersTableViewProps) => {
    const {
        members,
        segments,
        membersWithoutSegment,
        connectedMembers,
        newMembers,
    } = props;
    const translate = useTranslate();

    return (
        <div className='overflow-y-auto flex-column gap-20 padding-right10'>
            {connectedMembers.length > 0 && (
                <MembersTableSection
                    name={translate('my_connections')}
                    items={connectedMembers}
                    visibleSegmentName={true}
                    visibleNewMember={true}
                />
            )}
            {newMembers.length > 0 && (
                <MembersTableSection
                    name={translate('new_plural')}
                    items={newMembers}
                    visibleSegmentName={true}
                />
            )}
            {segments.map(segment => {
                const segmentMembers = members.filter(
                    member =>
                        member.idAccountManagmentSegment ===
                        parseInt(segment.id)
                );
                if (!segmentMembers.length) return null;
                return (
                    <MembersTableSection
                        key={segment.id}
                        name={segment.name}
                        items={segmentMembers}
                        visibleNewMember={true}
                    />
                );
            })}
            {membersWithoutSegment.length > 0 ? (
                <MembersTableSection
                    name={translate('other-rest')}
                    items={membersWithoutSegment}
                    visibleNewMember={true}
                />
            ) : (
                ''
            )}
            {members.length === 0 && (
                <Card>
                    <p className='text-align-center'>
                        {translate('no_results')}
                    </p>
                </Card>
            )}
        </div>
    );
};

export default MembersTableView;
